import { render, staticRenderFns } from "./ModalGaleriaAssinatura.vue?vue&type=template&id=618531ac&scoped=true&"
import script from "./ModalGaleriaAssinatura.vue?vue&type=script&lang=js&"
export * from "./ModalGaleriaAssinatura.vue?vue&type=script&lang=js&"
import style0 from "./ModalGaleriaAssinatura.vue?vue&type=style&index=0&id=618531ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618531ac",
  null
  
)

export default component.exports